import { Z_EMAIL, Z_FIRST_NAME, Z_JOB, Z_LAST_NAME, Z_PHONE } from '@common/schemas';
import { z } from 'zod';

const editFirstAdminSchema = z.object({
  firstAdminLastName: Z_LAST_NAME,
  firstAdminFirstName: Z_FIRST_NAME,
  firstAdminJob: Z_JOB,
  firstAdminPhoneNumber: Z_PHONE,
  firstAdminEmail: Z_EMAIL,
});

const editFirstAndSecondAdminSchema = editFirstAdminSchema.extend({
  secondAdminLastName: Z_LAST_NAME,
  secondAdminFirstName: Z_FIRST_NAME,
  secondAdminJob: Z_JOB,
  secondAdminPhoneNumber: Z_PHONE,
  secondAdminEmail: Z_EMAIL,
});

export const createEditFirstAdminSchemaAsyncEmail = (
  emailAsyncValidation: (email: string) => Promise<boolean>,
) =>
  editFirstAdminSchema.superRefine(async (data, ctx) => {

    // Validation asynchrone de l'email 1
    if (data.firstAdminEmail) {
      const isEmail1Valid = await emailAsyncValidation(data.firstAdminEmail);
      if (!isEmail1Valid) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Cet email est déjà utilisé',
          path: ['firstAdminEmail'],
        });
      }
    }
  });

export const createEditFirstAndSecondAdminSchemaAsyncEmail = (
  emailAsyncValidation: (email: string) => Promise<boolean>,
) =>
  editFirstAndSecondAdminSchema.superRefine(async (data, ctx) => {
    if (data.firstAdminEmail &&
      data.secondAdminEmail &&
      data.firstAdminEmail === data.secondAdminEmail) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'L\'adresse mail doit être différente de celle du second administrateur.',
        path: ['firstAdminEmail'],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'L\'adresse mail doit être différente de celle du premier administrateur.',
        path: ['secondAdminEmail'],
      });
    }

    // Validation asynchrone de l'email 1
    if (data.firstAdminEmail) {
      const isEmail1Valid = await emailAsyncValidation(data.firstAdminEmail);
      if (!isEmail1Valid) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Cet email est déjà utilisé',
          path: ['firstAdminEmail'],
        });
      }
    }

    // Validation asynchrone de l'email 2
    if (data.secondAdminEmail) {
      const isEmail2Valid = await emailAsyncValidation(data.secondAdminEmail);
      if (!isEmail2Valid) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Cet email est déjà utilisé',
          path: ['secondAdminEmail'],
        });
      }
    }
  });

export type EditFirstAdminSchemaResult = z.infer<typeof editFirstAdminSchema>;
export type EditFirstAndSecondAdminSchemaResult = z.infer<typeof editFirstAndSecondAdminSchema>;
export type EditAdminFormResult = EditFirstAdminSchemaResult | EditFirstAndSecondAdminSchemaResult;

